import { useEffect, useState } from "react";
import { ColumnItem } from "../../../common/models/table";
import { ActionsKey } from "../../../common/models/Actions";
import { HttpStatusCode } from "axios";
import { Loader } from "../../../common/components/Loader/Loader";
import { TitleHeader } from "../../../common/components/TitleHeader/TitleHeader";
import { LFTableV3 } from "../../../common/components/LFTable/LFTableV3";
import { CustomDrawer } from "../../../common/components/Drawer/CustomDrawer";
import { useGateInListState, useGateInStore } from "./store/_gateInStore";
import { GateInService } from "./store/_requests";
import { GateInDetails } from "./components/GateInDetails";
import { Filters } from "../components/Filters";
import { API_URLs } from "../../../utilities/API_URLs";

export const GateIn = () => {

  const {
    setGateInList,
    gateInList,
    actioned,
    totalItems,
    setActioned,
  } = useGateInStore();
  const { pageState, setPageState, resetPageState } =
    useGateInListState();

  const [isShowForm, setIsShowForm] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const cols: ColumnItem[] = [
    {
      key: "reference",
      title: "Référence",
      dataIndex: "reference",
      // searchKey: "reference",
      // searchType: "text",
      show: true,
    },
    {
      key: "gateOutReference",
      title: "Réf. Gate Out",
      dataIndex: "gateOutReference",
      // searchType: "text",
      show: true,
    },
    {
      key: "bookingReference",
      title: "N° Booking",
      dataIndex: "bookingReference",
      // searchKey: "bookingReference",
      // searchType: "text",
      show: true,
    },
    {
      key: "bookingBlNumber",
      title: "N° BL",
      dataIndex: "bookingBlNumber",
      searchKey: "customerRemovalControl.booking.blNumber",
      searchType: "text",
      show: true,
    },
    {
      key: "restitutionSource",
      title: "Source",
      dataIndex: "restitutionSource",
      show: true,
      render: (source: any) => {
        return (<span>{source?.name ?? "-" }</span>)
      }
    },
    {
      key: "destination",
      title: "Destination",
      dataIndex: "destination",
      nestedKey: "destination.name",
      show: true,
      render: (destination: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{destination?.name}</span>
          </div>
        );
      },
    },
    {
      key: "checkedBy",
      title: "Contrôlé par",
      dataIndex: "checkedBy",
      nestedKey: "checkedBy.fullname",
      show: true,
      render: (checkedBy: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{checkedBy?.fullname}</span>
          </div>
        );
      },
    },
    {
      key: "createdAt",
      title: "Date de création",
      dataIndex: "createdAt",
      show: true,
    },
  ];

  useEffect(() => {
    fetchAllGateIn(pageState);
  }, [pageState]);

  const onActionClick = async (item: any, action: ActionsKey) => {
      try {
        setIsLoading(true);
    
        const res = await GateInService.getGateInById(item?.id);
    
        if (res?.status === HttpStatusCode.Ok) {
          setActioned({
            data: {
              ...res?.data,
            },
            action,
          });
    
          setIsShowForm(true);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

  const handleCloseDrawer = () => {
    setIsShowForm(false);
  };

  const fetchAllGateIn = async (params?: any) => {
    try {
      setIsLoading(true);
      const res = await GateInService.getGateInList(params);
      if (res?.status === HttpStatusCode.Ok) {
        setGateInList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  return (
    <div className="">
      <Loader isLoading={isLoading} />
      <TitleHeader
        title="Restitution (Gate In)"
      />
      <Filters
        uri={API_URLs.customerRestitutionControl.customerRestitutionSourcesForSelect}
        filterKey="restitutionSource"
        params={pageState}
        initialParams={{
          page: 1,
          itemsPerPage: 10,
          pagination: true,
        }}
        onChange={handleSetParams}
      />
      <div className="mt-4">
        {/* Table section  */}
        <div className="">
          <LFTableV3
            columns={cols}
            data={gateInList}
            params={pageState}
            onAction={onActionClick}
            isCanShow={() => true}
            onSearch={handleSetParams}
            //onSort={handleSetParams}
            onResetSearch={resetPageState}
            pagination={{
              defaultCurrentPage: pageState.page,
              itemsPerPage: pageState?.itemsPerPage,
              totalItems: totalItems,
            }}
            onChangePage={handleSetParams}
          />
        </div>
      </div>

      {/* Drawer section  */}
      {isShowForm ? (
        <CustomDrawer
          isOpen={isShowForm}
          onClose={handleCloseDrawer}
          title={"Détails"}
          width={"75%"}
        >
          <GateInDetails value={actioned?.data}/>
        </CustomDrawer>
      ) : (
        ""
      )}
    </div>
  );
};
